var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNocheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.537 0C17.9082 0.0992578 18.3323 0.0870117 18.7197 0.13793C26.0004 1.1015 31.9101 6.99381 32.8621 14.2854C32.9123 14.6728 32.9014 15.0969 33 15.4688V17.5312C32.9007 17.9025 32.913 18.3272 32.8621 18.7146C31.8985 25.9978 26.0087 31.9101 18.7197 32.8621C18.3323 32.9123 17.9082 32.9014 17.537 33H15.4751C15.1039 32.9007 14.6798 32.913 14.2924 32.8621C7.01237 31.8979 1.10199 26.0062 0.15066 18.7146C0.100386 18.3272 0.111343 17.9031 0.0127296 17.5312C0.0423782 16.8493 -0.0272315 16.1487 0.0127296 15.4688C0.490974 7.28643 7.29597 0.478887 15.4751 0H17.537ZM16.3001 3.88652C12.9614 4.05217 13.711 6.64125 13.8032 8.98863C13.9521 12.7933 14.1377 16.6005 14.3188 20.3968C14.373 21.5312 14.0803 22.4271 15.0239 23.3004C15.8644 24.0778 17.149 24.0778 17.9888 23.3004C18.933 22.4265 18.6404 21.5306 18.6939 20.3968C18.8969 16.1294 19.1393 11.8446 19.274 7.57066C19.2985 6.79014 19.5286 5.82527 19.0955 5.11178C18.5373 4.19139 17.3217 3.83625 16.2995 3.88652H16.3001ZM16.2344 24.768C13.4513 25.0697 13.7568 29.5447 16.9202 29.127C19.4976 28.7867 19.2018 24.4458 16.2344 24.768Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNocheck);
export default __webpack_public_path__ + "static/media/nocheck.8b0461a50f8ed1d4993630025bfd1732.svg";
export { ForwardRef as ReactComponent };